
<template>
  <v-container >
    <v-layout row wrap justify-center>
      <v-flex xs12 md8 lg6>
        <v-card>
          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-text-field v-model="Profile.FIO" label="ФИО" required></v-text-field>
              <v-text-field v-model="Profile.phone" :rules="[rules.required]" label="Телефон"></v-text-field>
              <v-text-field v-model="Profile.email" label="Email" readonly></v-text-field>
              <v-text-field v-model="Profile.city" label="Город"></v-text-field>
              <v-text-field v-model="Profile.address" label="Адрес"></v-text-field>
              <v-text-field v-model="Profile.passport" label="Данные паспорта"></v-text-field>
              <!--
              <v-text-field v-model="selectedPhoto.name" label="Avatar" prepend-icon='attach_file' @click="$refs.avatar.click()"></v-text-field>
              <input type="file" style="display: none" ref="avatar" accept="image/*" @change="getFile">
              -->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="orange" @click="updateProfile()">Обновить данные</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="6000"
      :top="true"
      :bottom="false"
      :right="true"
      :left="false"
      :multi-line="false"
      :vertical="true"
      v-model="snackbar"
    >
      {{ message }}
      <v-btn flat color="pink" @click.native="snackbar = false">Закрыть</v-btn>
    </v-snackbar>
    <div class="overlay" v-if="ready">
      <div class="flex-spinner">
        <v-progress-circular :size="200" :width="7" indeterminate color="amber"></v-progress-circular>
      </div>
    </div>
  </v-container>
</template>

<script>
//TODO2 email менять - отдельную процедуру

import Profile from './../../models/Profile';
import { mapState } from 'vuex';

export default {
  mounted () {
    console.log('UpdateProfile.mounting');

    this.$auth.check().then(user => {
      //console.log('UpdateProfile.mounted');
      //this.Profile = this.$store.state.auth.profile
      this.ready = false;
     });
  },
  data () {
    return {
      message: '',
      selectedPhoto: { name: '' },
      error: '',
      snackbar: false,
      ready: true,
      emailRules: [
        v => !!v || "E-mail обязателен",
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail некорректен"
      ],
      rules: {
        required: value => !!value || 'Обязательное поле.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
  //    ...mapState('auth',{Profile: state=>state.profile})
    };
  },
  watch: {
    '$store.state.auth.profileReady': () => {
      console.log('watch profile ');
      this.ready = false
      //this.Profile = this.$store.state.auth.profile
    }
  },
  computed: {
    ...mapState('auth',{Profile: state=>state.profile})
  },
  methods: {
    getFile (e) {
      this.selectedPhoto = e.target.files[0]
    },
    updateAvatar () {
      if (!this.selectedPhoto) {
        return
      }
      this.ready = true
      let name = this.Profile.uid
      this.$storage.upload({
        ref: `/images/${name}`,
        file: this.selectedPhoto,
        progress: snapshot => { },
        error: err => {
          this.message = err.message
          this.snackbar = true
        },
        completed: downloadURL => {
          this.updateProfilePicture(downloadURL)
          .then(() => {
            this.message = 'Ваш аватар обновлен'
            this.snackbar = true
            this.selectedPhoto = { name: "" }
            this.ready = false
          }).catch(error => {
              this.message = error.message
              this.snackbar = true
          })
        }
      })
    },
    updateProfilePicture (fileName) {

      this.Profile.photoURL = fileName
      return this.$auth.updateProfilePicture(fileName)
    },
    updateProfile () {

      this.ready = true
      this.$store.dispatch('auth/saveProfile', this.Profile)
      // this.$auth
      //   .user()
      //   .updateProfile(this.Profile.toJson())
        .then(() => {
          // if (this.selectedPhoto.type != undefined) {
          //   this.updateAvatar()
          // } else {
            this.message = 'Ваш профиль обновлен'
            this.snackbar = true
            this.ready = false
          // }
        })
        .catch(error => {
          this.message = error.message
          this.snackbar = true
          this.ready = false
        });
    },
    synchronize () {
      //this.Profile.setPhotoURL(this.$auth.user().photoURL)
    }
  }
};
</script>

<style scoped>
  /* Styles */
</style>



// WEBPACK FOOTER //
// UpdateProfile.vue?8608039a